export default __webpack_public_path__ + "static/media/sales.7c3fc8c8.svg";